module.exports = __webpack_public_path__ + "pos-connectivity.svg?9700988850c0be4125ce916ea70a303c";